import React from "react";
import Clock from "./Clock";
import Weather from "./Weather";
import "./Dashboard.css";

export default function Dashboard() {
  return (
    <div className="Dashboard-card">
      <Clock />
      <div className="Dashboard-divider" />
      <Weather />
    </div>
  );
}
